export interface fnCallable {
	stripeUpdateBillingEmail: string;
	stripeGetRecentInvoices: string;
	stripeGetBusinessBalance: string;
}

export const fnCallable: fnCallable = {
	stripeUpdateBillingEmail: 'stripe_updateBillingEmail',
	stripeGetRecentInvoices: 'stripe_getRecentInvoices',
	stripeGetBusinessBalance: 'stripe_getBusinessBalance',
};

export interface UpdateBillingEmailRequest {
	email: string;
}

export interface GetRecentInvoicesSummaryResponse<T> {
	rows: T[];
	hasMore: boolean;
}

export interface Customer {
	balance?: number;
}
